import React from 'react'
import { FaWhatsapp, FaFacebookF, FaTwitter, FaInstagram, FaCcMastercard, FaCcPaypal, FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa'
import { Link } from 'react-router-dom'

function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    quickLinks: [
      { name: 'About Us', path: '/about' },
      { name: 'Contact Us', path: '/contact' },
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Terms & Conditions', path: '/terms' },
      { name: 'Return Policy', path: '/return-policy' },
    ],
    myAccount: [
      { name: 'My Account', path: '/account' },
      { name: 'Order History', path: '/orders' },
      { name: 'Wishlist', path: '/wishlist' },
      { name: 'Newsletter', path: '/newsletter' },
    ]
  }

  return (
    <footer className="bg-gray-900 text-gray-300 mt-auto">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="space-y-4">
            <div className="w-40 h-12">
              <img 
                alt="Poshinds Logo" 
                src='images/logo.png' 
                className='w-full h-full object-contain brightness-0 invert'
              />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Premium quality products delivered to your doorstep. Your trusted shopping destination since 2020.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-3 text-sm">
                <FaPhoneAlt className="text-blue-400 text-sm" />
                <a href="tel:+923276558052" className="hover:text-white transition-colors">+92 327 6558052</a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <FaEnvelope className="text-blue-400 text-sm" />
                <a href="mailto:info@apnabachatbazar.com" className="hover:text-white transition-colors">info@apnabachatbazar.com</a>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <FaMapMarkerAlt className="text-blue-400 text-sm" />
                <span>Gujranwala</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {footerLinks.quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* My Account */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">My Account</h3>
            <ul className="space-y-2">
              {footerLinks.myAccount.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter & Social */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4">Stay Connected</h3>
            <p className="text-sm text-gray-400 mb-4">
              Subscribe to get special offers, free giveaways, and exclusive deals.
            </p>
            <div className="flex mb-6">
              <input 
                type="email" 
                placeholder="Your email address"
                className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-l-lg focus:outline-none focus:border-blue-500 text-sm"
              />
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-r-lg transition-colors text-sm font-medium">
                Subscribe
              </button>
            </div>
            
            {/* Social Icons */}
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/Poshinds" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <FaFacebookF className="text-gray-400 hover:text-white text-sm" />
              </a>
              <a 
                href="https://twitter.com/poshinds" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-400 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <FaTwitter className="text-gray-400 hover:text-white text-sm" />
              </a>
              <a 
                href="https://www.instagram.com/poshinds/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <FaInstagram className="text-gray-400 hover:text-white text-base" />
              </a>
              <a 
                href="https://wa.me/923277569895" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-green-600 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
              >
                <FaWhatsapp className="text-gray-400 hover:text-white text-base" />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Flag Counter - Optional */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex justify-center">
            <a href="https://info.flagcounter.com/IXfw" target="_blank" rel="noopener noreferrer">
              <img 
                src="https://s11.flagcounter.com/count2/IXfw/bg_1F2937/txt_9CA3AF/border_374151/columns_2/maxflags_10/viewers_0/labels_0/pageviews_0/flags_0/percent_0/" 
                alt="Flag Counter" 
                border="0"
                className="opacity-75 hover:opacity-100 transition-opacity"
              />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            <div className="text-sm text-gray-500">
              © {currentYear} HrBachatBazar. All rights reserved.
            </div>
            <div className="text-xs text-gray-600">
              Powered by Developing Desk
            </div>
            <div className="flex items-center gap-3">
              <div className="flex items-center gap-2">
                <FaCcMastercard className="text-gray-500 text-2xl" />
                <span className="text-xs text-gray-500">Secure Payment</span>
              </div>
              <div className="flex items-center gap-2">
                <FaCcPaypal className="text-gray-500 text-2xl" />
                <span className="text-xs text-gray-500">PayPal</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer